



import React, { Component } from 'react';
import { getTrans, getTeamDeadlineObj } from '../../common';
import { Consume } from '../../Context/Consumer';
import { TransContext, PlayerDetailTogglerContext } from '../../Context/index'
import config from '../../common/config';


class BottomPlayerDetailsStrip extends Component {





    render() {

        let bottomPlayerDetailsStrip = null;
        let { player, TransData, PlayerDetailTogglerData, mode, isLateOnboarding, isBench } = this.props;
        let trans = TransData.data;
        let isSubsMode = mode == config.modes.substitution;
        let isPlayed = player.DBDetails.isactive == 0 ? true : false;
        let showPoints = false;
        let points = "-";
        if (player.details['totPts'] !== null && player.details['totPts'] !== "" && player.details['totPts'] !== undefined) {
            points = player.details['totPts'];
        }
        let playerPoints = points;
        if (isSubsMode) {
            if (player.DBDetails.overallpoints !== "" && player.DBDetails.overallpoints !== null && player.DBDetails.overallpoints !== undefined) {
                playerPoints = player.DBDetails.overallpoints ? player.DBDetails.overallpoints : 0;
            } else {
                playerPoints = "-"
            }

        }

        if (playerPoints !== "" && playerPoints !== undefined && playerPoints !== null && playerPoints !== "-") {
            showPoints = true
        }


        switch (PlayerDetailTogglerData.value) {
            case (0): {
                //price
                bottomPlayerDetailsStrip = <div className="si-plyr__val">
                    <div className="si-currency">
                        <span>€</span>
                        <span>{ player.details.value }</span>
                        <span>{ getTrans(trans, ('million_short'), 'm') }</span>
                    </div>
                </div>

                break;
            }
            case (1): {
                //fixtures
                if (mode == config.modes.substitution && showPoints) {
                    if (isBench) {
                        bottomPlayerDetailsStrip = <div className={ isLateOnboarding && isPlayed ? "si-plyr__val si-pts--invalid" : "si-plyr__val" + (showPoints ? " si-pts--invalid" : "") } >

                            <span>{ (playerPoints) + " " + (showPoints ? getTrans(trans, 'lablePts', 'pts') : "") }</span>

                        </ div>
                        break;
                    } else {
                        bottomPlayerDetailsStrip = <div className={ isLateOnboarding && isPlayed ? "si-plyr__val si-pts--invalid" : "si-plyr__val" + (showPoints ? " si-pts--final" : "") } >

                            <span>{ (playerPoints) + " " + (showPoints ? getTrans(trans, 'lablePts', 'pts') : "") }</span>

                        </ div>
                        break;
                    }

                } else {
                    let UpComingMatchesList = player.details && player.details['upcomingMatchesList'] ? player.details['upcomingMatchesList'] : [];
                    if (isLateOnboarding && isPlayed) {
                        UpComingMatchesList = player.details && player.details['currentMatchesList'] ? player.details['currentMatchesList'] : [];
                    }

                    let vsObj = {};
                    let vsTeam = '-';
                    if (UpComingMatchesList.length > 0) {
                        vsObj = UpComingMatchesList[0];
                    }
                    if (vsObj.hasOwnProperty('vsCCode')) {
                        vsTeam = vsObj['vsCCode'];
                    }



                    bottomPlayerDetailsStrip = <div className="si-plyr__val">
                        <span>{ vsTeam ? getTrans(trans, ('vs_short'), 'vs') : "-" } </span>
                        <span className="si-vsStrip">{ vsTeam }</span>
                    </div>
                    if (mode == config.modes.substitution || mode === config.modes["live"] || mode === config.modes["viewpoint"]) {
                        if (player.DBDetails.vscountrycode) {
                            bottomPlayerDetailsStrip = <div className="si-plyr__val">
                                <span>{ player.DBDetails.vscountrycode ? getTrans(trans, ('vs_short'), 'vs') : "-" } </span>
                                <span className="si-vsStrip">{ player.DBDetails.vscountrycode ? player.DBDetails.vscountrycode : vsTeam }</span>
                            </div>
                        }

                    }

                    if (isLateOnboarding && isPlayed) {
                        bottomPlayerDetailsStrip = <div className="si-plyr__val si-pts--invalid">
                            <span>{ vsTeam ? getTrans(trans, ('vs_short'), 'vs') : "-" } </span>
                            <span className="si-vsStrip">{ vsTeam ? vsTeam : "" }</span>
                        </div>
                    }

                    break;
                }

            }
            case (2): {
                //Points
                let showPoints = false;
                let points = "-";
                if (player.details['totPts'] !== null && player.details['totPts'] !== "" && player.details['totPts'] !== undefined) {
                    points = player.details['totPts'];
                }
                let playerPoints = points;
                if (isSubsMode) {
                    if (player.DBDetails.overallpoints !== "" && player.DBDetails.overallpoints !== null && player.DBDetails.overallpoints !== undefined) {
                        playerPoints = player.DBDetails.overallpoints ? player.DBDetails.overallpoints : 0;
                    } else {
                        playerPoints = "-"
                    }

                }

                if (playerPoints !== "" && playerPoints !== undefined && playerPoints !== null && playerPoints !== "-") {
                    showPoints = true
                }

                if (isBench) {
                    bottomPlayerDetailsStrip = <div className={ isLateOnboarding && isPlayed ? "si-plyr__val si-pts--invalid" : "si-plyr__val" + (showPoints && mode == config.modes.substitution ? " si-pts--invalid" : "") } >

                        <span>{ (playerPoints) + " " + (showPoints ? getTrans(trans, 'lablePts', 'pts') : "") }</span>

                    </ div>
                    break;
                } else {
                    bottomPlayerDetailsStrip = <div className={ isLateOnboarding && isPlayed ? "si-plyr__val si-pts--invalid" : "si-plyr__val" + (showPoints && mode == config.modes.substitution ? " si-pts--final" : "") } >

                        <span>{ (playerPoints) + " " + (showPoints ? getTrans(trans, 'lablePts', 'pts') : "") }</span>

                    </ div>
                }
                break;
            }
            case (3): {
                //Date
                if (mode == config.modes.substitution && showPoints) {
                    if (isBench) {
                        bottomPlayerDetailsStrip = <div className={ isLateOnboarding && isPlayed ? "si-plyr__val si-pts--invalid" : "si-plyr__val" + (showPoints ? " si-pts--invalid" : "") } >

                            <span>{ (playerPoints) + " " + (showPoints ? getTrans(trans, 'lablePts', 'pts') : "") }</span>

                        </ div>
                        break;
                    } else {
                        bottomPlayerDetailsStrip = <div className={ isLateOnboarding && isPlayed ? "si-plyr__val si-pts--invalid" : "si-plyr__val" + (showPoints ? " si-pts--final" : "") } >

                            <span>{ (playerPoints) + " " + (showPoints ? getTrans(trans, 'lablePts', 'pts') : "") }</span>

                        </ div>
                        break;
                    }


                } else {
                    let classname = "si-plyr__val"
                    let UpComingMatchesList = player.details && player.details['upcomingMatchesList'] ? player.details['upcomingMatchesList'] : [];

                    if (isLateOnboarding && isPlayed) {
                        UpComingMatchesList = player.details && player.details['currentMatchesList'] ? player.details['currentMatchesList'] : [];
                        classname = "si-plyr__val si-pts--invalid"
                    }


                    let date = "-"

                    date = UpComingMatchesList.length ? UpComingMatchesList[0].matchDate ? UpComingMatchesList[0].matchDate : "-" : "-";
                    if (mode == config.modes.substitution) {
                        date = player.DBDetails.mhdate ? player.DBDetails.mhdate : player.details['upcomingMatchesList'].length ? player.details['upcomingMatchesList'][0].matchDate ? player.details['upcomingMatchesList'][0].matchDate : "-" : "-"
                    }

                    if (date && date != "-") {
                        date = getTeamDeadlineObj(trans, config.WebConfig.OffSet, date).displayDate;
                        date = date ? date.toLowerCase() == "invalid date" ? "-" : date : "-"
                    }

                    bottomPlayerDetailsStrip = <div className={ classname }>

                        <span>{ date }</span>

                    </div>
                    break;
                }
            }
            default: {
                break;
            }
        }

        return (<React.Fragment>
            { bottomPlayerDetailsStrip }
        </React.Fragment>
        )
    }
};



export default (Consume(BottomPlayerDetailsStrip, [TransContext, PlayerDetailTogglerContext]));




